<template>
  <el-checkbox-group v-model="currentValue" @change="onChange">
    <el-checkbox
      v-for="item in checkList"
      :label="item.id"
      :key="item.id"
      :disabled="item.disabled"
      >{{ item.name_cn }}</el-checkbox
    >
  </el-checkbox-group>
</template>

<script>
import { GetCaseTypesList } from "@/views/caseTypes/api";
export default {
  props: {
    value: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },

  data() {
    return {
      showMoreFilter: false,
      currentValue: [],
      checkList: [],
    };
  },
  watch: {
    value: {
      handler(newVal) {
        this.currentValue = [...newVal];
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.initData();
  },

  methods: {
    initData() {
      GetCaseTypesList({
        page: 0,
        size: 1000,
        disabled: false,
        sort: "seq asc",
      }).then((res) => {
        let { content } = res.data;
        this.checkList = content;
      });
    },
    onChange(value) {
      console.log("选中", value);
      this.$emit("input", value);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .el-input__inner {
    height: 42px;
    overflow: hidden;
  }
}
</style>
